import { accountWiseBreakupService } from '../../services';

interface IConfig {
  getAccountWiseBreakupReport: (params: any) => Promise<any>;
  downloadAccountWiseReport: (params: any) => Promise<any>;
}

export const config: IConfig = {
  getAccountWiseBreakupReport: (params: any) =>
    accountWiseBreakupService.getAccountWiseBreakupReport(params),
  downloadAccountWiseReport: (params: any) =>
    accountWiseBreakupService.downloadServiceOrAccountWiseReport(params),
};

export const formatLabel = (label: string) => {
  return label
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
